import * as types from './types';
import * as constants from './constants';
import { Relationship, RelPoint, Field } from 'src/config';
import { TabProps } from '@mui/material';
import { isPersistent } from './utils';
import { Dictionary } from 'lodash';

export const startFetch = (
    request: types.FetchRequest,
    full: boolean,
    force: boolean = false
): types.StartFetchAction => {
    return {
        type: constants.START_FETCH,
        request,
        full,
        force,
    }
}

export const setEntity = (
    locator: types.Locator,
    entity: types.Entity,
): types.SetEntityAction => {
    return {
        type: constants.SET_ENTITY,
        locator,
        entity,
    }
}

export const setErrors = (
    locator: types.Locator,
    errors: types.Errors,
): types.SetErrorsAction => {
    return {
        type: constants.SET_ERRORS,
        locator,
        errors,
    }
}

export const pushAction = (
    locator: types.Locator,
    vector: RelPoint,
): types.PushAction => {
    return {
        type: constants.PUSH,
        locator,
        vector,
    }
}

export const pop = (
): types.PopAction => {
    return {
        type: constants.POP,
    }
}

export const goto = (
    index: number
): types.GotoAction => {
    return {
        type: constants.GOTO,
        index,
    }
}

export const reset = (
    locator: types.Locator,
): types.ResetAction => {
    return {
        type: constants.RESET,
        locator,
    }
}

export const link = (
    locator: types.Locator,
    vector: RelPoint,
    ids: types.ID[],
): types.LinkAction => {
    return {
        type: constants.LINK,
        locator,
        vector,
        ids
    }
}

export const unlink = (
    locator: types.Locator,
    vector: RelPoint,
    ids: types.ID[],
): types.UnLinkAction => {
    return {
        type: constants.UNLINK,
        locator,
        vector,
        ids: ids.map(id => id.toString())
    }
}

export const linkHard = (
    locator: types.Locator,
    vector: RelPoint,
    ids: types.ID[],
): types.LinkHardAction => {
    return {
        type: constants.LINK_HARD,
        locator,
        vector,
        ids
    }
}

export const unlinkHard = (
    locator: types.Locator,
    vector: RelPoint,
    ids: types.ID[],
): types.UnLinkHardAction => {
    return {
        type: constants.UNLINK_HARD,
        locator,
        vector,
        ids: ids.map(id => id.toString())
    }
}

export const deleteRelAction = (
    locator: types.Locator,
    vector: RelPoint,
    ids: types.ID[],
): types.DeleteRelatedAction => {
    return {
        type: constants.DELETE_REL,
        locator,
        vector,
        ids: ids.map(id => id.toString()),
    }
}

export const deleteAction = (
    locator: types.Locator,
    onComplete?: types.onCompleteHandler,
): types.DeleteAction => {
    return {
        type: constants.DELETE,
        locator,
        onComplete,
    }
}

export const removeAction = (
    locator: types.Locator,
): types.RemoveAction => {
    return {
        type: constants.REMOVE,
        locator,
    }
}

export const submit = (
    locator: types.Locator,
    onComplete?: types.onCompleteHandler,
): types.SubmitAction => {
    return {
        type: constants.SUBMIT,
        locator,
        onComplete,
    }
}

export const cancel = (
    locator: types.Locator,
    onComplete?: types.onCompleteHandler,
): types.CancelAction => {
    return {
        type: constants.CANCEL,
        locator,
        onComplete,
    }
}

export const setFieldValAction = (
    locator: types.Locator,
    field: Field,
    value: types.Value,
): types.SetFieldValAction => {
    return {
        type: constants.SET_FIELD_VALUE,
        locator,
        field,
        value,
    }
}

export const setVectorAction = (
    locator: types.Locator,
    vector: RelPoint,
    ids: types.ID[],
    inclAttrs?: boolean,
): types.SetVectorAction => {
    return {
        type: constants.SET_VECTOR_VALUE,
        locator,
        vector,
        ids,
        inclAttrs,
    }
}

export const createNew = (
    name: string,
): types.CreateNewAction => {
    return {
        type: constants.CREATE_NEW,
        name,
    }
}

export const createTemp = (
    port: types.RelPort,
): types.CreateTempAction => {
    return {
        type: constants.CREATE_TEMP,
        port,
    }
}

export const setMorph = (
    locator: types.Locator,
    morph: string,
): types.SetMorphAction => {
    return {
        type: constants.SET_MORPH,
        locator,
        morph,
    }
}

export const setShowHiddenAction = (
    locator: types.Locator,
    sys: boolean,
): types.SetShowHiddenAction => {
    return {
        type: constants.SET_SHOW_HIDDEN,
        locator,
        sys,
    }
}

export const replaceId = (
    locator: types.Locator,
    id: types.ID,
): types.ReplaceIdAction => {
    return {
        type: constants.REPLACE_ID,
        locator,
        id,
    }
}

export const clear = (
): types.ClearAction => {
    return {
        type: constants.CLEAR,
    }
}
